var _style, _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMobileNav01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000005259074624339375210000015049667720287151799_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 425.2 425.2",
    style: {
      enableBackground: "new 0 0 425.2 425.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF5A60;}\r\n\t.st1{fill:#3C3E55;}\r\n\t.st2{display:none;}\r\n\t.st3{display:inline;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M213.1,70.1c40.7,0,81.3-0.1,122,0c23.2,0.1,37.3,12.2,37.6,31.4c0.2,19.3-14.2,31.9-37.1,32 c-82.4,0.1-164.8,0.1-247.2,0c-22.2,0-35.7-12.3-36-31.4c-0.2-19,13.7-31.8,35.5-31.9C129.7,69.9,171.4,70.1,213.1,70.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M213.1,180.8c40.7,0,81.4-0.1,122,0c23.1,0.1,37.5,12.3,37.6,31.4c0.1,19.4-14.2,32-37,32 c-82.5,0.1-164.8,0.1-247.3,0c-22.2,0-35.8-12.3-36-31.4c-0.2-19,13.7-31.9,35.4-32C129.7,180.7,171.4,180.8,213.1,180.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M211.7,355.1c-40.7,0-81.3,0.1-122,0c-23.2-0.1-37.2-12.3-37.2-31.8c0-19.6,13.9-31.7,37.3-31.7 c81.9-0.1,163.8-0.1,245.7,0c23,0,37.3,12.5,37.3,31.9c-0.1,19.3-14.4,31.5-37.5,31.5C294.1,355.3,253,355.1,211.7,355.1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M213.7,263.7c-6.6,6.7-13,13.5-19.6,20.1c-23.7,23.8-47.4,47.5-71.1,71.2c-13.3,13.3-35.6,13.2-49.1-0.3 c-13.5-13.3-13.5-35.6-0.1-49.1c29.5-29.6,59.1-59.2,88.7-88.7c0.6-0.6,1.2-1.4,2.4-2.6c-5.7-5.5-11.3-11-16.9-16.5 c-24.6-24.5-49.2-49.1-73.7-73.7c-9.7-9.8-12.9-21.7-9-35c3.9-13,12.8-21.2,26-24c12.6-2.6,23.7,1,32.9,10.2 c29.2,29.2,58.4,58.4,87.6,87.6c0.7,0.7,1.3,1.3,2.8,2.6c5.7-5.9,11.2-11.8,16.9-17.5c24.4-24.5,48.9-49,73.4-73.5 c13.6-13.6,35.7-13.8,49.1-0.5c13.9,13.8,14.1,35.8,0.3,49.7c-30.1,30.2-60.3,60.3-90.8,90.8c1.6,1.6,3.1,3.2,4.6,4.8 c28.6,28.6,57.3,57.2,85.9,85.9c9.9,9.9,12.9,22.1,8.8,35.4c-4,12.9-13.1,21-26.4,23.6c-12.7,2.4-23.6-1.5-32.8-10.7 c-29-29.2-58.2-58.2-87.3-87.3C215.6,265.5,214.9,264.9,213.7,263.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMobileNav01);
export default __webpack_public_path__ + "static/media/iconMobileNav01.7cff009a06b2a8237915106abe8d5c41.svg";
export { ForwardRef as ReactComponent };